module.exports = __webpack_public_path__ + "static/media/pokoje-1-min.e3c05b52.png";